import { MultiselectComponent } from "./component";
export const Multiselect = MultiselectComponent;
